var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgWarning = function SvgWarning(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.961 29.437 16.165 2.077a.19.19 0 0 0-.33 0L.038 29.438a.191.191 0 0 0 .166.287h31.592a.191.191 0 0 0 .166-.287M3.337 27.724l11.64-20.162-.542-1.538 1.326-.646 12.902 22.346z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.011 22.37c-.085 0-.137.052-.137.136v2.082c0 .085.051.136.137.136h1.979c.085 0 .136-.051.136-.136v-2.082c0-.084-.051-.136-.136-.136zm-.034-9.568V20.8c0 .052.034.086.085.086h1.876c.052 0 .085-.035.085-.086v-8c0-.05-.034-.084-.085-.084h-1.876a.08.08 0 0 0-.085.085",
    fill: "#000"
  })));
};
export default SvgWarning;